// removed by extract-text-webpack-plugin
module.exports = {"breakpoint":"768"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/nav.scss
// module id = 453
// module chunks = 1